import type { NewLeagueTeamWithoutRank } from "./newLeague.ts";

// Source metadata describing a new league seed. Used by NewLeague to pass
// gameAttributes, startingSeason, teams, and related info into createLeague.
// The optional fields are populated piecewise depending on the official mode.
export type NewLeagueSeedInfo = {
	gameAttributes?: Record<string, unknown>;
	startingSeason?: number;
	version?: number;
	teams?: NewLeagueTeamWithoutRank[];
	maxGid?: number;
	hasRookieContracts?: boolean;
};

export type NormalizedNewLeagueSeedInfo = {
	gameAttributes: Record<string, unknown> | undefined;
	startingSeason: number | undefined;
	version: number | undefined;
	teams: any[] | undefined;
	maxGid: number | undefined;
	hasRookieContracts: boolean;
};

export const normalizeNewLeagueSeedInfo = (
	sourceInfo?: NewLeagueSeedInfo,
): NormalizedNewLeagueSeedInfo => ({
	gameAttributes: sourceInfo?.gameAttributes,
	startingSeason: sourceInfo?.startingSeason,
	version: sourceInfo?.version,
	teams: sourceInfo?.teams,
	maxGid: sourceInfo?.maxGid,
	hasRookieContracts: sourceInfo?.hasRookieContracts ?? true,
});
